<template>
    <div class="flex-1">
        <h4 class="px-5 mt-5">Настройки - Интеграции</h4>
        <h5 class="px-5 py-2">Службы-доставки</h5>
        <div class="d-flex flex-column flex-grow px-5">
            <div class="row">
                <div class="col-md-4">
                    <nav class="nav flex-column h-100">
                        <router-link to="/get/pochta" active-class="active" class="nav-link nav-link-s">Почта России</router-link>
                        <router-link to="/get/del_line" active-class="active" class="nav-link nav-link-s">Деловые Линии</router-link>
                        <router-link to="/get/gtd" active-class="active" class="nav-link nav-link-s">GTD (KIT)</router-link>
                        <router-link to="/get/cdek" active-class="active" class="nav-link nav-link-s">CDEK</router-link>
                        <router-link to="/get/boxberry" active-class="active" class="nav-link nav-link-s">Boxberry</router-link>
                        <router-link to="/get/pec" active-class="active" class="nav-link nav-link-s">ПЭК</router-link>
                        <router-link to="/get/dpd" active-class="active" class="nav-link nav-link-s">DPD</router-link> 
                        <router-link to="/get/iml" active-class="active" class="nav-link nav-link-s">IML</router-link>
                    </nav>
                </div>
                <div class="col-md-8">
                    <keep-alive>
                        <router-view class="view"></router-view>
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import Cdek from '@/components/cdek'
import Boxberry from '@/components/boxberry'
import Pec from '@/components/pec'
import Pochta from '@/components/pochta'
import Dpd from '@/components/dpd'
import DelLine from '@/components/del_line'
import Gtd from '@/components/gtd'
import Iml from '@/components/iml'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/get/cdek', name: 'cdek', component: Cdek},
    { path: '/get/boxberry', name: 'boxberry', component: Boxberry},
    { path: '/get/pec', name: 'pec', component: Pec},
    { path: '/get/pochta', name: 'pochta', component: Pochta},
    { path: '/get/dpd', name: 'dpd', component: Dpd},
    { path: '/get/del_line', name: 'del_line', component: DelLine},
    { path: '/get/gtd', name: 'gtd', component: Gtd},
    { path: '/get/iml', name: 'iml', component: Iml}
  ]
})

export default {
  name: 'Integration',
  router,
  data: function() {
    return {
      
    }
  },
  created: function() {
    
  },
}
</script>
<style scope>
.nav-link-s{
    background-color: #e5eaed;
    font-size: 14px;
    padding: 13px 15px !important;
    color: rgba(0,0,0,0.7);
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 3px;
}
.nav-link.nav-link-s.router-link-exact-active.active{
    background-color: transparent !important;
    color: #000 !important;
}
</style>
